import { KostenneutraleVerlaengerungDisplayModel, KostenneutraleVerlaengerungDisplayModelFormGroup } from '@/api/model-index';
import { AenderungsantragService, AnfrageService } from '@/api/service-index';
import { Constants } from '@/constants';
import { MoveDirection } from '@/core/components/anfrage-navigation-form/anfrage-navigation-form.component';
import { I18nService } from '@/core/services/i18nService';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { StateService } from '@/core/services/state.service';
import { TextBoxService } from '@/core/services/textbox.service';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { convertJSDateString } from '@/core/utils/date-converter';
import { Component } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseAenderungsantragNavigationFormComponent } from '../base-aenderungsantrag-navigation-form/base-aenderungsantrag-navigation-form.component';

@Component({
    selector: 'kostenneutrale-verlaengerung',
    templateUrl: './kostenneutrale-verlaengerung.component.html',
    styleUrls: ['./kostenneutrale-verlaengerung.component.scss'],
    standalone: false
})
export class KostenneutraleVerlaengerungComponent extends BaseAenderungsantragNavigationFormComponent {
  public form: KostenneutraleVerlaengerungDisplayModelFormGroup;
  public aenderungsantragConfig = Constants.AENDERUNGSANTRAG;

  public get formGroup(): FormGroup<any> {
    return this.form;
  }

  public get dateFormat(): string {
    return this.languageService.GetCurrentShortDateFormat(true);
  }

  constructor(
    protected sectionService: SectionService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected portalContextService: PortalContextService,
    protected aenderungsantragService: AenderungsantragService,
    protected loadingAnimationService: LoadingAnimationService,
    protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService,
    protected languageService: I18nService,
    protected stateService: StateService,
    protected anfrageService: AnfrageService,
    protected textBoxService: TextBoxService,
  ) {
    super(sectionService, router, route, portalContextService, stateService);
    this.form = KostenneutraleVerlaengerungDisplayModelFormGroup.Instance;
  }

  protected initForm(): void {
    const aenderungsantraeg: KostenneutraleVerlaengerungDisplayModel = this.route.snapshot.data.aenderungsantrag;

    this.form.VerlaengertBis.addValidators(Validators.required);

    this.form.patchValue({
      ...aenderungsantraeg,
      verlaengertBis: aenderungsantraeg.verlaengertBis ? new Date(aenderungsantraeg.verlaengertBis) : null,
    });
  }

  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {
    const aenderungsAntrag: KostenneutraleVerlaengerungDisplayModel = this.form.value;

    if (aenderungsAntrag && shouldSave && this.form.dirty) {
      aenderungsAntrag.verlaengertBis = convertJSDateString(aenderungsAntrag.verlaengertBis);

      this.form.markAsPristine();
      if (moveDirection != MoveDirection.STAY) {
        if (this.canceledRoute) {
          this.router.navigateByUrl(this.canceledRoute);
        } else {
          this.move(moveDirection);
        }
      }

      const foundIndex = this.portalContextService.Aenderungsantraege!.findIndex(a => a.id == aenderungsAntrag.id);
      if (foundIndex >= 0) {
        this.portalContextService.Aenderungsantraege![foundIndex] = aenderungsAntrag;
      }

      let subscription = this.aenderungsantragService.apiAenderungsantragKostenneutraleVerlaengerungPatch({ body: aenderungsAntrag })
        .subscribe(() => {
          this.form.markAsPristine();

          this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id, aenderungsantragId: aenderungsAntrag.id }).subscribe(result => {
            this.stateService.ValidationErrors = result;
          })
        }, (error) => {
          this.form.markAsDirty();
          throw error;
        });

      this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
      this.unfinishedHttpMethodsService.addSubscription(subscription);
    } else {
      this.form.markAsPristine();
      this.move(moveDirection);
    }
  }
}
